import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import '@/global/css/styles.css'
import '../node_modules/@fortawesome/fontawesome-pro/js/all.min.js'
import '../node_modules/@fortawesome/fontawesome-pro/js/sharp-solid.min.js'

createApp(App).use(router).mount('#app');